/*
 * Copyright (c) 2020. Sanish Manandhar
 * All Rights Reserved
 */

// Import actionType constants
import {
  PAYMENT_ADD_REQUEST,
  PAYMENT_ADD_REQUEST_SUCCESS,
  PAYMENT_ADD_REQUEST_FAILURE,
  PAYMENT_PARTNERS_LIST_REQUEST,
  PAYMENT_PARTNERS_LIST_REQUEST_SUCCESS,
  PAYMENT_PARTNERS_LIST_REQUEST_FAILURE,
  PAYMENT_PARTNER_SECRET_REQUEST,
  PAYMENT_PARTNER_SECRET_REQUEST_SUCCESS,
  PAYMENT_PARTNER_SECRET_REQUEST_FAILURE,
  PAYMENTS_LIST_FETCH_REQUEST,
  PAYMENTS_LIST_FETCH_REQUEST_SUCCESS,
  PAYMENTS_LIST_FETCH_REQUEST_FAILURE,
  CLEAN_PAYMENTS_PROPS,
  CLEAN_PAYMENTS_LIST_PROPS,
  PAYMENT_MODE_FETCH_REQUEST,
  PAYMENT_MODE_FETCH_REQUEST_SUCCESS,
  PAYMENT_MODE_FETCH_REQUEST_FAILURE,
  BANK_ACCOUNT_TYPE_FETCH_REQUEST,
  BANK_ACCOUNT_TYPE_FETCH_REQUEST_SUCCESS,
  BANK_ACCOUNT_TYPE_FETCH_REQUEST_FAILURE,
  PAYMENT_MODE_FILTER_FETCH_REQUEST,
  PAYMENT_MODE_FILTER_FETCH_REQUEST_SUCCESS,
  PAYMENT_MODE_FILTER_FETCH_REQUEST_FAILURE,
  SINGLE_PAYMENT_FETCH_REQUEST,
  SINGLE_PAYMENT_FETCH_REQUEST_SUCCESS,
  SINGLE_PAYMENT_FETCH_REQUEST_FAILURE,
  CLEAN_SINGLE_PAYMENT_PROPS,
  SAVE_PAYMENT_ERROR_MESSAGE_REQUEST,
  SAVE_PAYMENT_ERROR_MESSAGE_REQUEST_SUCCESS,
  SAVE_PAYMENT_ERROR_MESSAGE_REQUEST_FAILURE,
} from './type';

const INITIAL_STATE = {
  paymentPayload: [],
  paymentLoading: false,
  paymentErrors: {},
  paymentPartnersPayload: [],
  paymentPartnersLoading: false,
  paymentPartnersErrors: {},
  paymentPartnerSecretLoading: false,
  paymentPartnerSecretPayload: [],
  paymentPartnerSecretErrors: {},
  paymentsListPayload: [],
  paymentsListErrors: {},
  paymentsListLoading: false,
  paymentListPagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  paymentMode: [],
  paymentModeLoading: false,
  paymentModeErrors: {},
  bankAccountType: [],
  bankAccountTypeLoading: false,
  bankAccountTypeErrors: {},
  paymentModeFilter: [],
  paymentModeFilterLoading: false,
  paymentModeFilterErrors: {},
  singlePayment: [],
  singlePaymentLoading: false,
  singlePaymentError: {},
};

const paymentReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case PAYMENT_ADD_REQUEST:
      return Object.assign({}, state, {
        paymentLoading: true,
      });

    case PAYMENT_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        paymentLoading: false,
        paymentPayload: action.data,
        paymentErrors: {},
      });

    case PAYMENT_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        paymentLoading: false,
        paymentErrors: action.error,
      });

    case PAYMENT_MODE_FETCH_REQUEST:
      return Object.assign({}, state, {
        paymentModeLoading: true,
      });

    case PAYMENT_MODE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        paymentMode: action.data,
        paymentModeLoading: false,
        paymentModeErrors: {},
      });

    case PAYMENT_MODE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        paymentModeLoading: false,
        paymentModeErrors: action.error,
      });

    case PAYMENT_PARTNERS_LIST_REQUEST:
      return Object.assign({}, state, {
        paymentPartnersLoading: true,
      });
    case PAYMENT_PARTNERS_LIST_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        paymentPartnersLoading: false,
        paymentPartnersPayload: action.data,
        paymentPartnersErrors: {},
      });
    case PAYMENT_PARTNERS_LIST_REQUEST_FAILURE:
      return Object.assign({}, state, {
        paymentPartnersLoading: false,
        paymentPartnersErrors: action.error,
      });

    case PAYMENT_PARTNER_SECRET_REQUEST:
      return Object.assign({}, state, {
        paymentPartnerSecretLoading: true,
      });
    case PAYMENT_PARTNER_SECRET_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        paymentPartnerSecretLoading: false,
        paymentPartnerSecretPayload: action.data,
        paymentPartnerSecretErrors: {},
      });
    case PAYMENT_PARTNER_SECRET_REQUEST_FAILURE:
      return Object.assign({}, state, {
        paymentPartnerSecretLoading: false,
        paymentPartnerSecretErrors: action.error,
      });

    case CLEAN_PAYMENTS_PROPS:
      return Object.assign({}, state, {
        paymentPayload: [],
        paymentLoading: false,
        paymentErrors: {},
        paymentPartnersPayload: [],
        paymentPartnersLoading: false,
        paymentPartnersErrors: {},
        paymentPartnerSecretLoading: false,
        paymentPartnerSecretPayload: [],
        paymentPartnerSecretErrors: {},
      });

    case PAYMENTS_LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        paymentsListLoading: true,
      });
    case PAYMENTS_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        paymentsListLoading: false,
        paymentsListPayload: action.data,
        paymentsListErrors: {},
        paymentListPagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });
    case PAYMENTS_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        paymentsListLoading: false,
        paymentsListErrors: action.error,
      });

    case CLEAN_PAYMENTS_LIST_PROPS:
      return Object.assign({}, state, {
        paymentsListLoading: false,
        paymentsListPayload: [],
        paymentsListErrors: {},
      });

    case BANK_ACCOUNT_TYPE_FETCH_REQUEST:
      return Object.assign({}, state, {
        bankAccountTypeLoading: true,
      });

    case BANK_ACCOUNT_TYPE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        bankAccountType: action.data,
        bankAccountTypeLoading: false,
        bankAccountTypeErrors: {},
      });

    case BANK_ACCOUNT_TYPE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        bankAccountTypeLoading: false,
        bankAccountTypeErrors: action.error,
      });

    case PAYMENT_MODE_FILTER_FETCH_REQUEST:
      return Object.assign({}, state, {
        paymentModeFilterLoading: true,
      });

    case PAYMENT_MODE_FILTER_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        paymentModeFilter: action.data,
        paymentModeFilterLoading: false,
        paymentModeFilterErrors: {},
      });

    case PAYMENT_MODE_FILTER_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        paymentModeFilterLoading: false,
        paymentModeFilterErrors: action.error,
      });

    case SINGLE_PAYMENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        singlePaymentLoading: true,
      });

    case SINGLE_PAYMENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singlePayment: action.data,
        singlePaymentLoading: false,
        singlePaymentError: {},
      });

    case SINGLE_PAYMENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singlePaymentLoading: false,
        singlePaymentError: action.error,
      });

    case CLEAN_SINGLE_PAYMENT_PROPS:
      return Object.assign({}, state, {
        singlePayment: [],
        singlePaymentLoading: false,
        singlePaymentError: {},
      });

    case SAVE_PAYMENT_ERROR_MESSAGE_REQUEST:
      return Object.assign({}, state, {
        savePaymentErrorMessageLoading: true,
      });

    case SAVE_PAYMENT_ERROR_MESSAGE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        savePaymentErrorMessage: action.data,
        savePaymentErrorMessageLoading: false,
        savePaymentErrorMessageError: {},
      });

    case SAVE_PAYMENT_ERROR_MESSAGE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        savePaymentErrorMessageLoading: false,
        savePaymentErrorMessageError: action.error,
      });

    default:
      return state;
  }
};

export default paymentReducer;
